import React from 'react';
import { Link } from 'react-router-dom';
import { BreadcrumbItem } from './types';

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
  className?: string;
}

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items, className = '' }) => {
  if (items.length === 0) return null;

  return (
    <nav
      className={`flex items-center space-x-1 text-md text-complementary-text min-w-0 overflow-hidden ${className}`}
      aria-label="Breadcrumb"
    >
      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        return (
          <React.Fragment key={index}>
            {index > 0 && (
              <svg className="w-4 h-4  mx-1" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
                <path
                  fillRule="evenodd"
                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                  clipRule="evenodd"
                />
              </svg>
            )}

            {isLast ? (
              <span className="font-medium text-title" aria-current="page" data-testid={`breadcrumb-current-${index}`}>
                {item.label}
              </span>
            ) : item.path ? (
              <Link to={item.path} className="transition-colors" data-testid={`breadcrumb-link-${index}`}>
                {item.label}
              </Link>
            ) : (
              <span className="" data-testid={`breadcrumb-text-${index}`}>
                {item.label}
              </span>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
};
